import {useEffect,useState,useCallback,useRef} from 'react';
import {useCanvasStore} from './canvas-store';
import {FIRST_AD_PROMPT} from './first-ad-prompt';
export function useFirstAdPrompt(eligible:boolean,brandId:number|null,setInput:(value:string)=>void,draft=''){
 const pending=useCanvasStore(s=>s.pendingFirstAdBrandId);
 const [active,setActive]=useState(false);
 const typing=useRef<ReturnType<typeof setInterval>|null>(null);
 const started=useRef(false);
 const finish=useCallback(()=>{
  if(!started.current)return;
  if(typing.current)clearInterval(typing.current);typing.current=null;
  setInput(FIRST_AD_PROMPT);setActive(false);started.current=false;
 },[setInput]);
 useEffect(()=>{
  if(!eligible||!pending||pending!==brandId)return;
  useCanvasStore.setState({pendingFirstAdBrandId:null});
  // Returning from setup must not replace an existing unsent brief.
  if(draft.trim())return;
  started.current=true;setActive(true);setInput('');
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches){setInput(FIRST_AD_PROMPT);return;}
  let index=0;
  typing.current=setInterval(()=>{setInput(FIRST_AD_PROMPT.slice(0,++index));if(index>=FIRST_AD_PROMPT.length&&typing.current){clearInterval(typing.current);typing.current=null;}},38);
 },[pending,eligible,brandId,setInput,draft]);
 useEffect(()=>{if(!eligible){if(typing.current)clearInterval(typing.current);typing.current=null;started.current=false;setActive(false);}},[eligible]);
 useEffect(()=>()=>{if(typing.current)clearInterval(typing.current);},[]);
 return {active,finish};
}
